<template>
    <Primary :inverted="inverted ?? false" is="button" class="cursor-pointer">
        <slot/>
    </Primary>
</template>
<script setup>
import Primary from "@/Components/Primary.vue";

defineProps({
    inverted: {
        type: Boolean,
        required: false,
    },
});
</script>
